import { render, staticRenderFns } from "./SolicitacaoSkeleton.vue?vue&type=template&id=999a0546&scoped=true&"
import script from "./SolicitacaoSkeleton.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoSkeleton.vue?vue&type=style&index=0&id=999a0546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999a0546",
  null
  
)

export default component.exports